// ============================================================================
// Form Config: RuleSets
// Key: ruleSets
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import type { FormSection } from '@/shared/forms/GenericForm'
import { enumFormOptions } from '../../entity-config-runtime/entity-form-config'
import { CustomPropertyLinkRuleType } from '../api/backstage.schemas'
// #endregion

// #region Create Form
export const ruleSetsCreateFormConfig: FormSection[] = [
	{
		title: 'forms_rule_sets_create_section_main',
		fields: [
			{
				name: 'name',
				label: 'forms_rule_sets_create_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'description',
				label: 'forms_rule_sets_create_description',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'color',
				label: 'forms_rule_sets_create_color',
				type: 'color' as const,
				initialValue: '',
			},
			{
				name: 'tabColor',
				label: 'forms_rule_sets_create_tab_color',
				type: 'color' as const,
				initialValue: '',
			},
			{
				name: 'contactColor',
				label: 'forms_rule_sets_create_contact_color',
				type: 'color' as const,
				initialValue: '',
			},
			{
				name: 'italic',
				label: 'forms_rule_sets_create_italic',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'bold',
				label: 'forms_rule_sets_create_bold',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'underline',
				label: 'forms_rule_sets_create_underline',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'isHidden',
				label: 'forms_rule_sets_create_is_hidden',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'replaceValue',
				label: 'forms_rule_sets_create_replace_value',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'link',
				label: 'forms_rule_sets_create_link',
				type: 'select' as const,
				options: enumFormOptions(
					CustomPropertyLinkRuleType,
					'CustomPropertyLinkRuleType',
				),
				initialValue: '',
			},
			{
				name: 'linkDisplayName',
				label: 'forms_rule_sets_create_link_display_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'openContactDetailBeforeAccepting',
				label: 'forms_rule_sets_create_open_contact_detail_before_accepting',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'hideValue',
				label: 'forms_rule_sets_create_hide_value',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'showInSplit',
				label: 'forms_rule_sets_create_show_in_split',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'maxWidth',
				label: 'forms_rule_sets_create_max_width',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'minWidth',
				label: 'forms_rule_sets_create_min_width',
				type: 'text' as const,
				initialValue: '',
			},
		],
	},
]
// #endregion

// #region Edit Form
export const ruleSetsEditFormConfig: FormSection[] = [
	{
		title: 'forms_rule_sets_edit_section_main',
		fields: [
			{
				name: 'name',
				label: 'forms_rule_sets_edit_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'description',
				label: 'forms_rule_sets_edit_description',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'color',
				label: 'forms_rule_sets_edit_color',
				type: 'color' as const,
				initialValue: '',
			},
			{
				name: 'tabColor',
				label: 'forms_rule_sets_edit_tab_color',
				type: 'color' as const,
				initialValue: '',
			},
			{
				name: 'contactColor',
				label: 'forms_rule_sets_edit_contact_color',
				type: 'color' as const,
				initialValue: '',
			},
			{
				name: 'italic',
				label: 'forms_rule_sets_edit_italic',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'bold',
				label: 'forms_rule_sets_edit_bold',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'underline',
				label: 'forms_rule_sets_edit_underline',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'isHidden',
				label: 'forms_rule_sets_edit_is_hidden',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'replaceValue',
				label: 'forms_rule_sets_edit_replace_value',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'link',
				label: 'forms_rule_sets_edit_link',
				type: 'select' as const,
				options: enumFormOptions(
					CustomPropertyLinkRuleType,
					'CustomPropertyLinkRuleType',
				),
				initialValue: '',
			},
			{
				name: 'linkDisplayName',
				label: 'forms_rule_sets_edit_link_display_name',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'openContactDetailBeforeAccepting',
				label: 'forms_rule_sets_edit_open_contact_detail_before_accepting',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'hideValue',
				label: 'forms_rule_sets_edit_hide_value',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'showInSplit',
				label: 'forms_rule_sets_edit_show_in_split',
				type: 'checkbox' as const,
				initialValue: false,
			},
			{
				name: 'maxWidth',
				label: 'forms_rule_sets_edit_max_width',
				type: 'text' as const,
				initialValue: '',
			},
			{
				name: 'minWidth',
				label: 'forms_rule_sets_edit_min_width',
				type: 'text' as const,
				initialValue: '',
			},
		],
	},
]
// #endregion

// #region Forms Config Export
export const ruleSetsFormsConfig = {
	create: ruleSetsCreateFormConfig,
	edit: ruleSetsEditFormConfig,
} as const
// #endregion
